import React, { Component } from 'react'
import algoliasearch from 'algoliasearch/lite';
import { InstantSearch, Configure, SearchBox } from 'react-instantsearch-dom'
import { GoogleMapsLoader } from 'react-instantsearch-dom-maps'
import Stats from './Stats'
import Content from './Content'
import Geo from './Geo'
import './App.css'

const searchClient = algoliasearch(
    'CJHIB3S51Y',
    'af30b5f8177768f08bc97d0d939b5a74'
  );

class App extends Component {
  render() {
    return (
      <InstantSearch indexName="test" searchClient={searchClient}>
        <Configure
          hitsPerPage={20}
          getRankingInfo
          aroundLatLngViaIP
          typoTolerance="min"
        />
        <main className="search-container">
          <div className="right-panel">
            <div id="map">
              <div style={{ height: '100%' }}>
                <GoogleMapsLoader apiKey="AIzaSyBawL8VbstJDdU5397SUX7pEt9DslAwWgQ">
                  {google => <Geo google={google} />}
                </GoogleMapsLoader>
              </div>
            </div>
            <div id="searchbox">
              {/* Uncomment the following widget to add a search bar */}
              <SearchBox
                translations={{
                  placeholder: 'Search by store name, state, city'
                }}
              />

            </div>
            <div id="stats">
              {/* Uncomment the following widget to add search stats */}
              <Stats />
            </div>
          </div>
          <div className="left-panel">
            <div id="hits">
              {/* Uncomment the following widget to add hits list */}
              <Content />
            </div>
          </div>
        </main>
      </InstantSearch>
    )
  }
}

export default App
